import React, { useState } from "react";
import Footer from "../../components/general/footer.jsx";
import Tool from "../../components/general/tool.jsx";
import "../../assets/css/agency.css";
import NavBar from "../../components/general/navBar.jsx";
import Hero from "../../components/agency/hero.jsx";
import AgencyMap from "../../components/agency/agencyMap.jsx";

const Agency = () => {
  return (
    <section className="agency-hero-section" id="agency-hero">
      <NavBar />
      <Hero />
      <AgencyMap />
      <Tool />
      <Footer />
    </section>
  );
};

export default Agency;
